/**
 * Created by john on 8/31/15.
 */

'use strict';

const User = require('../models/User');
const RegionalInfoStore = require('../stores/RegionalInfoStore');
const regionalInfoActions = require('../actions/regionalInfoActions');
const FinancialAmountsConvert = require('bunsen/collections/ecomm/FinancialAmountsConvert');
const storage = require('dibs-browser-storage');
const localStorageHelper = storage.localStorage;
const sessionStorageHelper = storage.sessionStorage;
const currencyActionConstants = require('../constants/currencyActionConstants.es');
const allowedCurrency = require('dibs-currency-helpers/currencies');
const {
    URL: { queryKey }
} = require('bunsen/helpers/uri');
const {
    currencies: { CURRENCY_USD }
} = require('dibs-currency-helpers/constants');

const PREFERRED_CURRENCY = 'userCurrency';

const currencyActions = {

    _updateCurrency: (actionContext, payload, done) => {
        let {currency} = payload;

        if (allowedCurrency.indexOf(currency) === -1) {
            currency = CURRENCY_USD;
        }

        if (currency) {
            actionContext.dispatch(currencyActionConstants.CURRENCY_CHANGED, { currency });
        }
        done();
    },

    _updateSessionStorage: (actionContext, payload, done) => {
        const {currency} = payload;
        sessionStorageHelper.setItem(PREFERRED_CURRENCY, currency);
        done();
    },

    _updateLocalStorage: (actionContext, payload, done) => {
        const {currency} = payload;
        localStorageHelper.setItem(PREFERRED_CURRENCY, currency);
        done();
    },

    /**
     * Loads the preferred currency for logged out user.
     * From url query, if not then
     * from local storage, if no then
     * from session storage, if no then
     * from Regional Info
     * @param actionContext
     */
    _loadPreferredCurrency: (actionContext, payload, done) => {
        const localStoreCurrency = localStorageHelper.getItem(PREFERRED_CURRENCY);
        const sessionStoreCurrency = sessionStorageHelper.getItem(PREFERRED_CURRENCY);
        const regionalInfoStore = actionContext.getStore(RegionalInfoStore);
        const queryCurrency = queryKey.currency && queryKey.currency.length ? queryKey.currency.toUpperCase() : null;

        if (queryCurrency && allowedCurrency.indexOf(queryCurrency) !== -1) {
            const currency = queryCurrency;

            actionContext
                .executeAction(currencyActions.updateUserCurrency, {currency})
                .then(() => done());
        } else if (localStoreCurrency || sessionStoreCurrency) {
            const currency = localStoreCurrency || sessionStoreCurrency;

            actionContext
                .executeAction(currencyActions._updateCurrency, {currency})
                .then(() => done());
        } else {
            actionContext
                .executeAction(regionalInfoActions.loadRegionalInfo)
                .then(() => {
                    const currency = regionalInfoStore.getRegionalInfo().currency;

                    // If loadRegionalInfo empty, this action has to be resolved with default currency from UserStore
                    if (currency) {
                        return actionContext.executeAction(currencyActions._setRegionalCurrency, {currency});
                    }
                    return Promise.resolve();
                })
                .then(() => done())
                // If loadRegionalInfo fails, this action has to be resolved with default currency from UserStore
                .catch(() => done());
        }
    },

    _setRegionalCurrency: (actionContext, payload, done) => {
        actionContext.executeAction(currencyActions._updateSessionStorage, payload);
        actionContext.executeAction(currencyActions._updateCurrency, payload);
        done();
    },

    /**
     * Convert amount(s) from one currency to another
     * @param actionContext
     * @param payload
     * @param done
     */
    convertAmountsToCurrency: (actionContext, payload, done) => {
        const {amounts, toCurrency} = payload;

        if (amounts) {
            const financialAmounts = new FinancialAmountsConvert(amounts);
            financialAmounts.sync('create', financialAmounts)
                .then((response) => {
                    const convertedFinancialAmounts = new FinancialAmountsConvert(response.result);

                    convertedFinancialAmounts.each((convertedFinancialAmount, key) => {
                        amounts[key].converted = convertedFinancialAmount.getAmountIn(toCurrency);
                    });

                    done(null, amounts);
                }, (error) => {
                    done(error);
                });
        }
    },

    /**
     * Loads the default currency for the current user.
     * @param actionContext
     * @param payload
     * @param payload.userLoadOptions
     */
    loadCurrencyForUser: (actionContext, payload, done) => {
        Promise.resolve(User.load(payload.userLoadOptions))
            .then(() => {
                const userModel = User.getCurrentUser();

                /*
                    When the user is registering, we do an initial save on successful password entry,
                    and we login the user. User.load gets triggered and we get a default
                    currency(USD) from the BE. So we ignore this call, because otherwise we'll
                    overwrite the users currently set currency.
                */
                if (userModel.get('newUser')) {
                    userModel.set('newUser', false);
                    return Promise.resolve();
                } else {
                    const currency = User.getCurrency();
                    return actionContext.executeAction(currencyActions._updateCurrency, {currency});
                }
            })
            .catch(() => {
                return actionContext.executeAction(currencyActions._loadPreferredCurrency);
            })
            .then(() => {
                actionContext.dispatch(currencyActionConstants.CURRENCY_LOADED);
                done();
            });
    },

    updateUserCurrency: (actionContext, payload, done) => {
        const {currency} = payload;

        if (User.loggedIn()) {
            User.updateCurrency(currency);
        }

        actionContext.executeAction(currencyActions._updateLocalStorage, payload);
        actionContext.executeAction(currencyActions._updateCurrency, payload);

        done();
    }
};

module.exports = currencyActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/currencyActions.es.js